import type { BaseStateRecord, TimeMode } from '../types'

export const sumUntil = (series: number[], monthIndex: number) =>
  series.slice(0, monthIndex + 1).reduce((acc, value) => acc + value, 0)

export const metricAt = (series: number[], monthIndex: number, mode: TimeMode) =>
  mode === 'month' ? series[monthIndex] ?? 0 : sumUntil(series, monthIndex)

export const stateMetric = (state: BaseStateRecord, monthIndex: number, mode: TimeMode) =>
  metricAt(state.total, monthIndex, mode)

export const topStates = (states: BaseStateRecord[], monthIndex: number, mode: TimeMode, limit = 6) =>
  [...states]
    .map((state) => ({ state, value: stateMetric(state, monthIndex, mode) }))
    .sort((a, b) => b.value - a.value)
    .slice(0, limit)

export const formatNumber = (value: number) =>
  new Intl.NumberFormat('es-MX').format(Math.round(value))

export const formatPercent = (value: number) =>
  new Intl.NumberFormat('es-MX', { style: 'percent', maximumFractionDigits: 1 }).format(value)
